import { render, staticRenderFns } from "./media_holding_matches.vue?vue&type=template&id=497ae388&scoped=true"
import script from "./media_holding_matches.vue?vue&type=script&lang=js"
export * from "./media_holding_matches.vue?vue&type=script&lang=js"
import style0 from "./media_holding_matches.vue?vue&type=style&index=0&id=497ae388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ae388",
  null
  
)

export default component.exports